export default from './DesktopQuiz';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/DesktopQuiz/index.js